<template>
  <div>
    <MobileFooter
      v-if="
        commonStore.isMobile &&
        router.currentRoute.value.name === ROUTE_NAME.Main
      "
      ref="footer"
      class="footer"
    />
    <DesktopFooter
      v-if="
        commonStore.isDesktop &&
        router.currentRoute.value.name !== ROUTE_NAME.Main
      "
      ref="footer"
      class="footer"
    />
  </div>
</template>

<script setup lang="ts">
import DesktopFooter from '@components/common/DesktopFooter.vue';
import MobileFooter from '@components/common/MobileFooter.vue';
import { useCommonStore } from '@stores';
import router from '@infra/router';
import { ROUTE_NAME } from '@constants';
const commonStore = useCommonStore();
</script>
<style scoped lang="scss"></style>
